import { useState } from "react";
import Logo from "../assets/logo_2.png";
import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  Link,
  ListItem,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MLS from "../assets/mlsLogo.png";
import { ArrowForwardRounded } from "@mui/icons-material";
import { bpoTerms, mlsListingTerms } from "../constants";
import ListingTermsBlock from "./ListingTermsBlock";

const useStyles = makeStyles((theme) => ({
  wrap: {
    background: theme.palette.paper.main,
    padding: "7rem 0 2.5rem 0",

    [theme.breakpoints.down("md")]: {
      padding: "2.5rem 0",
    },
  },
  listItem: {
    textAlign: "center",
    fontSize: "1rem",
    [theme.breakpoints.down("md")]: {
      textAlign: "center",
    },
    "&:hover": {
      background: "transparent",
    },
  },
  footImg: {
    [theme.breakpoints.down("sm")]: {
      width: "60%",
    },
  },
}));

const Footer = () => {
  const classes = useStyles();
  const { vendor } = useParams();
  const path = useLocation().pathname;
  const navigate = useNavigate();

  const [isBioShort, setIsBioShort] = useState(true);

  const footerLinks = [
    {
      caption: "For Sellers",
      subs: [
        { name: "Find a Listing Agent", path: "/agents" },
        { name: "Open Houses", path: "/homes-for-sale" },
      ],
    },
    {
      caption: "For Buyers ",
      subs: [
        { name: "Find a Buyer's Agent", path: "/agents" },
        { name: "Find Home for Sale", path: "/homes-for-sale" },
      ],
    },
    {
      caption: "For Agents",
      subs: [{ name: "Join BPO Homes Realty", path: "/join" }],
    },
  ];

  const menu = [
    { name: "About", path: "/about" },
    { name: "Blog", path: "/blog" },
    { name: "Privacy Policy", path: "/privacy-policy" },
    { name: "Terms of Use", path: "/terms-of-use" },
    { name: "Disclaimers", path: "/disclaimers" },
  ];

  return (
    <Box className={classes.wrap}>
      <Container
        maxWidth="xl"
        sx={{
          position: "relative",
          px: 2.5,
          pb: 5,
        }}
      >
        <Box>
          <Grid container spacing={3}>
            {footerLinks.map((el, index) => {
              return (
                <Grid
                  key={el.caption}
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={4}
                  sx={{
                    border: index === 1 ? "1px solid" : "none",
                    borderColor: "border.lighter",
                    borderWidth: { xs: "1px 0", sm: "0 1px" },
                    textAlign: {
                      xs: index === 0 ? "left" : "center",
                    },
                    paddingRight: index === 1 ? 3 : "inherit",
                    paddingBottom: { xs: 3, sm: 0 },
                  }}
                >
                  <Stack
                    width="80%"
                    margin={{ xs: 0, sm: index !== 0 ? "0 auto" : "0" }}
                    alignItems="flex-start"
                  >
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: "24px",
                        paddingLeft: {
                          xs: "0",
                          sm: index !== 0 ? "16px !important" : "0",
                        },
                      }}
                      component={"p"}
                      mb={2}
                      variant="h6"
                    >
                      {el.caption}
                    </Typography>

                    {el.subs.map((list) => {
                      return (
                        <ListItem
                          key={list.name}
                          className={classes.listItem}
                          component={"a"}
                          button
                          sx={{
                            marginLeft: {
                              xs: "-16px",
                              sm: index === 0 ? "-16px !important" : "0",
                            },
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate(list.path);
                          }}
                        >
                          <Stack
                            direction={"row"}
                            alignItems={"center"}
                            gap={1}
                          >
                            <ListItemText>
                              <Typography
                                textAlign={index === 0 ? "left" : "center"}
                                component={"p"}
                                variant="body1"
                                color="button.link"
                              >
                                {list.name}
                              </Typography>
                            </ListItemText>
                            <ArrowForwardRounded
                              sx={{
                                color: "button.link",
                              }}
                            />
                          </Stack>
                        </ListItem>
                      );
                    })}
                  </Stack>
                </Grid>
              );
            })}
          </Grid>
        </Box>

        <Box pt={{ xs: 5, sm: 10 }} pb={{ xs: 0, sm: 2 }}>
          <Typography variant="body" color={"textSecondary"} textAlign="center">
            <Box mt={1.5}>
              <Typography variant="body" color={"GrayText"}>
                {isBioShort
                  ? (bpoTerms || "")?.slice(0, 300) +
                    (bpoTerms?.length > 300 ? "..." : "")
                  : bpoTerms}
              </Typography>
              {bpoTerms?.length > 300 && (
                <Button
                  sx={{
                    padding: "0 !important",
                    marginLeft: "5px",
                    textTransform: "capitalize",
                    textDecoration: "underline",
                  }}
                  color="secondary"
                  variant="text"
                  onClick={() => setIsBioShort((v) => !v)}
                >
                  {isBioShort ? "Show more" : "Show Less"}
                </Button>
              )}
            </Box>
          </Typography>
        </Box>
        <Divider sx={{ margin: "3rem 0" }} />
        <Box
          width={"50%"}
          margin={"0 auto"}
          display={"flex"}
          flexDirection={{ xs: "column", sm: "row" }}
          justifyContent="space-evenly"
          gap={3}
        >
          {menu.map((item) => {
            return (
              <Link
                style={{ cursor: "pointer", textAlign: "center" }}
                color="button.link"
                underline="none"
                key={item.name}
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(item.path);
                }}
              >
                <Typography variant="body2">{item.name}</Typography>
              </Link>
            );
          })}
        </Box>
        <Box textAlign={"center"} margin="2rem 0">
          <img
            src={Logo}
            alt="logo-foot"
            className={classes.footImg}
            width={"25%"}
            style={{ marginBottom: ".5rem" }}
          />
          <span
            style={{ display: "flex", gap: "2rem", justifyContent: "center" }}
          >
            <Typography variant="body2" color={"textSecondary"}>
              © BPO HOMES Inc
            </Typography>
          </span>
        </Box>

        {["/listing", "/open-houses"].some((p) => path.startsWith(p)) &&
          ["mls", "crmls"].includes(vendor) && (
            <ListingTermsBlock
              isBioShort={isBioShort}
              setIsBioShort={setIsBioShort}
              logo={MLS}
              terms={mlsListingTerms}
            />
          )}
      </Container>
    </Box>
  );
};

export default Footer;
